import moment from 'moment'

export const formatDate = (date: string | Date, format?: string) =>
    isValidDate(date) ? moment(date).format(format || 'DD-MM-YYYY') : null

export const formatTime = (time: string | Date, format?: string) =>
    isValidDate(time) ? moment(time).format(format || 'HH:mm') as string : null

export const formatDateTime = (dateTime: string | Date, format?: string) =>
    isValidDate(dateTime) ? moment(dateTime).format(format || 'DD-MM-YYYY HH:mm') : null

export const isValidDate = (date: string | Date) =>
    moment(date).isValid()



